import { environment } from '../../../../../environments/environment';
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {SvgIconComponent} from "angular-svg-icon";
import {SharedModule} from "../../../../shared/shared.module";
import {FormBuilder, FormGroup} from "@angular/forms";
import {NgForOf, NgIf} from "@angular/common";
import {CoreModule} from "../../../core.module";
import {EstablishmentService} from "../../../../services/establishment.service";
import {Establishment} from "../../../../models/Establishment";
import {Base64} from "../../../../shared/utils/utils.functions";
import {MissionService} from "../../../../services/mission.service";
import {AffectationService} from "../../../../services/affectation.service";


@Component({
  selector: 'app-candidate-details',
  templateUrl: './etb-details.component.html',
  standalone: true,
  imports: [
    MatTabGroup,
    SvgIconComponent,
    MatTab,
    SharedModule,
    NgIf,
    CoreModule,
    NgForOf
  ],
  styleUrl: './etb-details.component.scss'
})
export class EtbDetailsComponent implements OnInit {

  etb: Establishment
  affectationList: any;
  loading = false;

  constructor(
    private establishmentService: EstablishmentService,
    private affectationService: AffectationService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<EtbDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {


  }

  ngOnInit(): void {
    this.getCandidateDetailByIdEstaId();
    this.getAffectationServices();
  }

  round(num: number) {
    return Math.round(num)
  }


  onDialogClose(): void {
    this.dialogRef.close();
  }

  getAffectationServices() {
    let form = {
      keyword: '',
      etablissementId: this.data.etb.etbId,
      offset: 0,
      limit: 100,
    }
    this.affectationService.affectationServiceFilter(form, "/v2").subscribe({
      next: ({content, totalElements}) => {
        this.affectationList = content
        console.log("this.affectationList => ", this.data.etb.etbId);
      }
    })
  }

  getCandidateDetailByIdEstaId() {
    this.loading = true;
    this.establishmentService.getEstablishmentByIdV2(this.data.etb.etbId).subscribe({
      next: data => {
        this.etb = data;
        this.loading = false;
      }
    });
  }

  getImage(_dataFile: string | undefined): any {
    if (!_dataFile) return '/assets/images/no-picture.jpg';

    // Check if the input is a URL path (from the optimized backend)
    if (_dataFile.startsWith('/api/')) {
      // Return the full URL by combining with the API base URL
      return environment.api.BASE_URL + _dataFile;
    }

    // Legacy handling for base64 data
    let decoded = Base64.decode(_dataFile);
    let extension = undefined;
    let lowerCase = decoded.toLowerCase();
    if (lowerCase.indexOf('png') !== -1) extension = 'png';
    else if (lowerCase.indexOf('pdf') !== -1) extension = 'pdf';
    else extension = 'jpg';
    const arrayBuffer = this.base64ToArrayBuffer(_dataFile);
    const blob = new Blob([arrayBuffer], {
      type:
        extension == 'pdf' ? 'application/pdf' : 'image/' + extension,
    });
    const link = document.createElement('a');
    return URL.createObjectURL(blob);
  }

  base64ToArrayBuffer(base64: string) {
    const binaryString = atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return bytes.buffer;
  }


}
